import { Message } from 'element-ui';
// 合并两个数组并根据指定属性去重
export const mergeAndDistinctByProperty = (array1, array2, property) => {
    const combinedArray = [...array1, ...array2];
    const uniqueItems = new Map(combinedArray.map(item => [item[property], item]));
    return Array.from(uniqueItems.values());
};

// 校验配置明细数据
export const validatedTableData = data => {
    const disabledData = data.filter(item => !item.detailConfigurationDay).map(v => v.detailConfigurationName);
    const detailConfigurationNames = disabledData.join(',');
    if (disabledData.length) {
        Message.warning(`以下配置明细中司机收款时长为空，请填写后重新提交: ${detailConfigurationNames}`);
        return false;
    }
    return true;
};
